module.exports = __webpack_public_path__ + "assets/img/3_1300_big.8554e96c.jpg";